'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partner;

var _immutable = require('immutable');

var _PartnerActionTypes = require('../actionTypes/PartnerActionTypes');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var INITIAL_STATE = new _immutable.Map({
  requestState: RequestState.NOT_REQUESTED,
  partnerPrivacyLink: null,
  didShowPartnerPrivacy: false
});

function partner() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _PartnerActionTypes.REQUEST_PARTNER_PRIVACY_LINK:
      return state.set('requestState', RequestState.REQUESTED);
    case _PartnerActionTypes.SUCCEED_GET_PARTNER_PRIVACY_LINK:
      {
        return state.merge({
          requestState: RequestState.SUCCEEDED,
          partnerPrivacyLink: payload.partnerPrivacyLink,
          partnerCompany: payload.partnerCompany
        });
      }
    case _PartnerActionTypes.FAILED_GET_PARTNER_PRIVACY_LINK:
      return state.merge({
        requestState: RequestState.FAILED
      });
    case _PartnerActionTypes.DID_SHOW_PARTNER_PRIVACY:
      return state.merge({
        didShowPartnerPrivacy: payload
      });
    case _PartnerActionTypes.PORTAL_SELECTED:
      return state.set('portalId', payload);
    case _PartnerActionTypes.PARTNER_PROVISIONING_COMPLETED:
      return state.set('isProvisioned', true);
    case _PartnerActionTypes.PARTNER_PROVISIONING_FAILED:
      return state.set('error', payload);
    case _PartnerActionTypes.PARTNER_ID_FROM_QUERY_PARAM:
      return state.merge({
        partnerId: payload
      });
    default:
      return state;
  }
}
module.exports = exports['default'];